import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { TableTooltip } from '~src/spacesPlatform/components/tooltip/TableTooltip';
import { getCommonTableInfo, getGraphQLId, isContentInfoTable } from '~src/spacesPlatform/models/CommonTableInfo';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { TableThumbnail } from './TableThumbnail';


export class TableCard extends ContentCard {

    public render() {
        const { content, urls, allowDragAndDrop, hovered, selected } = this.props;
        const commonTable = getCommonTableInfo(content);
        const contentUrl = getTableContentUrl(urls, content);
        return (
            <div className={CardViewStyles.Card}>
                <TableThumbnail allowDragAndDrop={allowDragAndDrop}
                                content={commonTable}
                                contentUrl={contentUrl}
                                hovered={hovered}
                                selected={selected}
                                aria-label={content.name}
                />
                <div className={CardViewStyles.ActionRow}>
                    <span data-tb-test-id="table-name" className={CardViewStyles.ActionRowName} title={content.name}>
                        {content.name}
                    </span>
                    <span>
                        <CardPopoverWidget
                            content={content}
                            onTriggerClick={this.handleShowPopover}
                            popoverContent={this.renderPopoverContent()}
                            title={Messages.tableDetails()}
                        />
                    </span>
                {this.renderActionsMenu()}
                </div>
                <div className={CardViewStyles.CardDescription}>
                    {this.getDescription()}
                </div>
            </div>
        );
    }

    private renderPopoverContent = () => <TableTooltip content={this.props.content}
                            urls={this.props.urls}/>;
}

export function getTableContentUrl(urls: SpacesSiteUrls, content: IContentInfo): string {
    if (isContentInfoTable(content)) {
        const contentId = getGraphQLId(content);
        return urls.catalogTableUrl(contentId);
      }

    return getContentUrlForItem(content, urls);
}
